import React, { FC, Ref } from "react";
import * as styles from "./NavItem.module.scss";

import classNames from "classnames/bind";
export const cx = classNames.bind(styles);

export interface NavItemProps {
  variant: "secondary" | "primary";
  expandOnMobile?: boolean;
  className?: string;
  id?: string;
  inputRef?: Ref<HTMLDivElement>;
}

const NavItem: FC<NavItemProps> = ({
  variant,
  expandOnMobile,
  children,
  className = "",
  inputRef,
  id = undefined
}) => {
  return (
    <div
      ref={inputRef}
      className={cx(
        {
          navItem: true,
          navItemSecondary: variant == "secondary",
          navItemPrimary: variant == "primary",
          navItemExpandOnMobile: expandOnMobile
        },
        className
      )}
      data-navlink-id={id}
    >
      {children}
    </div>
  );
};

export default NavItem;
